import React from 'react';
import styles from '../assets/styles/ServiceContactUsSection.module.css';

const ServiceContactUsSection = ({ header, content }) => {
  return (
    <div>
      <div className={styles.serviceContactUsSection}>
        <div className={styles.header}>{header}</div>
        <div className={styles.contactUsText}>{content}  Please fill in the form below and we'll be in contact with you as soon as we can.</div>
      </div>
    </div>
  );
};

export default ServiceContactUsSection;